/*
 * BM product gallery — theme-owned fixes for the vendored Flickity fork.
 *
 * Two defects in assets/global.min.js stop the PDP media gallery reacting to a
 * finger swipe on mobile. Rather than editing that minified bundle (a theme
 * update would overwrite it), we override the two affected prototype methods
 * here, in code we own. Loaded right after global.min.js in layout/theme.liquid
 * with `defer`, so it runs before the fork initialises carousels on DOM ready.
 *
 * 1. fadeSlides() ships as an empty stub. With the "fade" effect, positionSlider
 *    delegates entirely to it, so the gallery never tracks the drag — nothing
 *    translates and no opacity is interpolated. Reimplemented below using the
 *    fork's own helpers (getFadeIndexes / wrapDifference / Slide#setOpacity),
 *    which are all present in the bundle but never called.
 *    The PDP gallery has since moved to the "slide" effect (templates/product.json),
 *    so this override no longer applies there — it stays because quick view and the
 *    featured-product section are still on fade and would break without it.
 *
 * 2. The wrapper forces dragThreshold to 55px below 1025px when wrapAround is
 *    on, discarding the 6px the product section asks for, so short flicks are
 *    ignored outright. We restore a usable threshold for the product media
 *    gallery only (options.isMedia); every other carousel keeps vendor behaviour.
 */
(function () {
  'use strict';

  var proto = window.Flickityt4s && window.Flickityt4s.prototype;
  if (!proto) return;

  // What sections/main-product.liquid asks for before the wrapper overrides it.
  var MEDIA_DRAG_THRESHOLD = 6;

  // --- 1. real fade rendering -------------------------------------------------
  proto.fadeSlides = function () {
    var slides = this.slides;
    if (!slides || slides.length < 2) return;

    var indexes = this.getFadeIndexes();
    var slideA = slides[indexes.a];
    var slideB = slides[indexes.b];
    if (!slideA || !slideB) return;

    var distance = this.wrapDifference(slideA.target, slideB.target);
    if (!distance) return;

    var progress = (-this.x - slideA.target) / distance;
    if (progress < 0) progress = 0;
    if (progress > 1) progress = 1;

    // Hide whatever we faded on the previous frame and is no longer in play,
    // otherwise a wrapped-around slide can be left visible on top.
    var faded = this._bmFadedSlides;
    if (faded) {
      for (var i = 0; i < faded.length; i++) {
        if (faded[i] !== slideA && faded[i] !== slideB) faded[i].setOpacity(0);
      }
    }

    slideA.setOpacity(1 - progress);
    slideB.setOpacity(progress);
    this._bmFadedSlides = [slideA, slideB];
  };

  // --- 2. usable drag threshold for the product media gallery -----------------
  var hasDragStarted = proto.hasDragStarted;
  proto.hasDragStarted = function (movePoint) {
    if (this.options && this.options.isMedia) {
      return Math.abs(movePoint.x) > MEDIA_DRAG_THRESHOLD;
    }
    return hasDragStarted.apply(this, arguments);
  };
})();
